//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Fields.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/ExternalFileReferenceAdapter.js";
import "../no/Expression.js";
let d=[[[0,"ChannelHasMeasureUnknown",1,0],[0,"ChannelName",1,0],[0,"ExternalFile",1,0],[0,"Interpolation",1,0],[1,"Offset",0,"Expression",0],[1,"ScaleFactor",0,"Expression",0],[1,"TimeDelta",0,"Expression",0],[0,"UserDefinedUnitType",1,"Unit",0]],[[["isMeasureFixed"],"SetMeasureFixed",{},1,0],[[],"Validate",{R_:{result:''}},0,0],[["referenceObjectId"],"GetExternalFileReferenceAdapter",{R_:{adapter:"ExternalFileReferenceAdapter"}},1,0],[["referenceObjectId","adapter"],"SetExternalFileReferenceAdapter",{},2,0],[["adapter"],"GetExternalFileDefinitionKey",{R_:{externalFileDefinitionKey:''}},1,0],[["referenceObjectId","referenceType","externalFileSpec"],"EstablishReference",{R_:{adapter:"ExternalFileReferenceAdapter"}},3,0]],[]];
SPLM.Fields.TimeSeriesProfileBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Fields.TimeSeriesProfileBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Fields.TimeSeriesProfileBuilder.InterpolationEnum = Object.freeze({
    "Linear" : "Linear", "Akima" : "Akima", "Akima72" : "Akima72", "Cubic" : "Cubic"});

export default SPLM;